<template>
  <div>
    <div class="page-title">
      {{ $t('customerService.payout_search') }}
    </div>
    <div class="queryOutPay page-container">

      <div class="filter-container">
        <!-- <div class="filter-container-tag">
          {{ $t('components.activity') }}
        </div> -->
        <!--交易id  -->
        <span class="search-label">{{ $t('customerService.transaction_id') }}:</span>
        <el-input v-model.trim="search.transaction_id" type="text" class="search-frame" clearable />

        <!--客户订单号  -->
        <span class="search-label">{{ $t('customerService.merchant_order_id') }}:</span>
        <el-input v-model.trim="search.mch_order_id" type="text" class="search-frame" clearable />

        <!-- 查询 -->
        <el-button class="search-btn" type="primary" icon="el-icon-search" @click="onClickSearchBtn">{{ $t('components.search') }}</el-button>
      </div>

      <div class="tableContainer">
        <el-table
          v-loading="listLoading"
          :data="tableData"
          stripe
          fit
          highlight-current-row
          style="width: 100%"
        >

          <el-table-column :label="$t('customerService.transaction_id')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.transaction_id }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('customerService.merchant_order_id')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.merchant_order_id }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('merchantAccount.recipient_channel')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.recipient_channel }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('merchantAccount.amount')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.po_trans_amount | toDivideWithDot }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('merchantAccount.po_fee')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.fee_split | toDivideWithDot }}</span>
            </template>
          </el-table-column>

          <el-table-column min-width="150" :label="$t('merchantAccount.po_trans_status')" align="center">
            <template slot-scope="scope">
              <el-tag class="tag-status" :type="getPoTransactionStatusStyle(scope.row.po_trans_status)">{{ getPoTransactionStatusLabel(scope.row.po_trans_status,scope.row.refund_type) }}</el-tag>
            </template>
          </el-table-column>

          <!-- <el-table-column :label="$t('customerService.app_name')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.app_name }}</span>
          </template>
        </el-table-column> -->

          <el-table-column :label="$t('merchantAccount.create_time')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.transaction_create_time }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('merchantAccount.complete_time')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.transaction_return_time }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('components.operation')" align="center" min-width="130">
            <template slot-scope="scope">
              <el-button type="info" size="small" plain @click="onClickDetailBtn(scope.row)">
                {{ $t('components.view_details') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination-container">
        <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="confirm" />
      </div>

      <po-details-modal ref="poMentDetailsModal" :detail-id="detailId" />
    </div>
  </div>
</template>

<script>

import { fetchPoOrderList, submitRefundInstruction } from '@/api/customer-service/customer-service'
import { poTransStatusWithRefundMap } from '@/utils/maps'

export default {
  name: 'Customer_Service_Query_Payout',
  components: {
    Paginator: () => import('@/views/components/Paginator'),
    PoDetailsModal: () => import('./components/Modal/PoDetailsModal')
  },
  data() {
    return {
      showFilterContent: true,
      search: {
        mch_order_id: ''
      },
      tableData: [],
      payTypeArr: [], // 支付类型数组
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      detailId: 0
    }
  },
  computed: {
    getPoTransactionStatusLabel() {
      return function(value, refund_type) {
        if (refund_type === 2) {
          value = 99
        }
        return poTransStatusWithRefundMap(value).label
      }
    },
    getPoTransactionStatusStyle() {
      return function(value) {
        return poTransStatusWithRefundMap(value).type
      }
    }
  },
  created() {
  },
  methods: {
    onClickDetailBtn(row) {
      this.detailId = row.transaction_id
      this.showPayDetailModal()
    },
    handleFilter(params = {}) {
      Object.assign(params, this.search)
      const newParam = this.filterEmptyParams(params)
      this.getPoOrderList(newParam)
    },
    // 过滤参数
    filterEmptyParams(params) {
      const newParam = {}
      // 过滤属性为空的值
      Object.keys(params).filter(item => params[item] || params[item] === 0).forEach((key) => {
        let value = params[key]
        if (typeof value === 'string') {
          value = value.trim()
        }
        newParam[key] = value
      })
      return newParam
    },
    showPayDetailModal() {
      this.$refs.poMentDetailsModal.changModalStatus(true)
    },
    onClickCancal(index) {
      this.tableData[index].refundTxt = ''
      this.tableData[index].popVisible = false
    },
    onClickRefundBtn(index) {
      // 请求接口
      submitRefundInstruction().then((res) => {
        if (res.code === 10000) {
          this.tableData[index].refundTxt = ''
          this.tableData[index].popVisible = false
        }
      }).catch((err) => {
        console.error('eee', err)
        this.tableData[index].refundTxt = ''
        this.tableData[index].popVisible = false
      })
    },
    onClickSearchBtn() {
      const { mch_order_id, transaction_id } = this.search
      if (!mch_order_id && !transaction_id) {
        this.$message.warning('At least one parameter')
        return
      }
      this.handleFilter(this.search)
    },
    // 获取请求列表
    getPoOrderList(params = {}) {
      this.listLoading = true
      fetchPoOrderList(params).then(res => {
        this.tableData = res.data.list
        this.listQuery.total = res.data.total
        this.listQuery.page = params.page ? params.page : 1
      }).finally(() => {
        this.listLoading = false
      })
    },
    confirm() {
      const params = {
        page: this.listQuery.page
      }
      this.handleFilter(params)
    },
    onClickFixedArrow() {
      this.showFilterContent = !this.showFilterContent
    },
    onClickReset() {
      this.search = {}
    }
  }
}
</script>

<style lang="scss" scoped>
.search-label{
  display: inline-block;
  padding-right: 5px;
  font-size: 14px;
  font-weight: 500;
  color: #606266;
  font-family: 'Poppins-Medium';
}
// 由于使用popover是挂着根节点上，所以样式只能单独写
.queryOutPay_btn-container{
  margin: 0 50px;
  display: flex;
  justify-content: space-between;
}
.queryOutPay_size-btn{
  width: 80px;
  height: 28px;
  line-height: 6px;
}
.queryOutPay_popover_title{
  text-align: center;
  color: #606266;
}
.queryOutPay_textarea{
  margin-bottom: 20px;
}
.queryOutPay{
  .filter-container{
    position: relative;
    text-align: right;
    margin-bottom: 24px;
  }

  .pagination-container{
    padding: 20px;
    margin-top: 0;
  }
   .search-frame {
      width: 256px;
      margin-bottom: 10px;
      margin-right: 16px;
  }
  // .search-btn {
  //   margin-left: 10px;
  // }
  .tag-status{
    // text-decoration: underline;
    // cursor: pointer;
  }
}

</style>
